import { Container } from '@mui/material'
import React from 'react'

const Statistics: React.FC = () => {
    return <Container>Statistiky</Container>
}

export default Statistics
